<template>
    <div>
        <p
            class="content"
            v-for="(item, index) in activedContent"
            :key="index"
        >{{ item }}</p>
    </div>
</template>
<script>
export default {
    props: {
        content: {
            type: String,
            default: ''
        }
    },
    watch: {
        'content': {
            handler: function(val) {
                this.initText()
            }
        }
    },
    data() {
        return {
            activedContent: []
        }
    },
    methods: {
        initText() {
            this.activedContent = this.content && this.content.split('\n')
        }
    }
}
</script>
<style lang="scss" scoped>
.content {
    //padding: 10px 60px 0;
    text-align: left;
    font-size: 12px;
    font-family: MicrosoftYaHei, PingFangSC;
    font-weight: normal;
    color: #202820;
    line-height: 24px;
    text-indent: 2em;
    margin-bottom: 8px;
}
@media screen and (min-width: 1920px) {
    .content {
        font-size: 16px !important;
        font-weight: normal;
        color: #202820 !important;
        line-height: 30px !important;
        text-indent: 2em !important;
        margin-bottom: 8px;
    }
}
</style>